export default {"src":"/_next/static/media/checked-circle-filled.e6272fb4.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};